export const defaultLang = "en";

export const getLang = () => {
  const lang = "en"; // @TODO in the future

  return lang || defaultLang;
};

const replaceTranslationValues = (text, values = {}) => {
  const keys = Object.keys(values);
  let newText = text;

  keys.forEach((key) => {
    newText = newText.replace(`{{${key}}}`, values[key]);
    newText = newText.replace(`{{ ${key} }}`, values[key]);
  });

  return newText;
};

const getTranslationValue = (key, values = {}) => {
  const lang = getLang();
  const translations = require(`../_langs/${lang}.js`).default;
  const translation = translations[key];

  if (typeof translation === "string") {
    return replaceTranslationValues(translation, values);
  }

  return null;
};

export const getTranslation = (key, values = {}) => {
  const translation = getTranslationValue(key, values);

  if (translation) {
    return translation;
  }

  // eslint-disable-next-line no-console
  console.error("Missing translation for: ", key);

  return `!${key}`;
};
